import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from '../../../../environments/environment';
import { toBoolean } from 'ng-zorro-antd/core/util';
declare global {
  interface Window {
    Pusher: any;
  }
}

window.Pusher = Pusher;

@Injectable({
  providedIn: 'root'
})
export class LaravelEchoService {
  public echo: Echo<any>;

  public initEcho(token: string): void {
    this.echo = new Echo({
      authEndpoint: environment.appRoot + '/broadcasting/auth',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      broadcaster: 'reverb',
      key: environment.echoKey,
      wsHost: environment.echoHost,
      wsPort: parseInt(environment.echoPort),
      forceTLS: toBoolean(environment.echoHttps),
      transports: ['ws'],
      disableStats: true,
    }
    );
  }
}
